const MachinePipelineCard = ({ row, canEdit, onPatch }) => {
    if (!row) return null;
    const progress = row.progress || { completed: 0, total: 18, percent: 0 };

    return (
        <article className="pipeline-card card card-inner">
            <header>
                <div>
                    <h5>{row.machine_name}</h5>
                    <p>
                        {row.node_id || "no IO node"}
                        {row.location_path ? ` · ${row.location_path}` : ""}
                    </p>
                </div>
                <div className="pipeline-summary">
                    <strong>
                        {progress.completed} of {progress.total}
                    </strong>
                    <span>{progress.percent}%</span>
                </div>
            </header>
            <div className="progress live-site-progress">
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${progress.percent}%` }}
                />
            </div>
            {canEdit ? (
                <div className="pipeline-actions">
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => onPatch(row.machine_id, { action: "mark_all", key: "sorted" })}
                    >
                        Mark all sorted
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => onPatch(row.machine_id, { action: "mark_all", key: "implemented" })}
                    >
                        Mark all implemented
                    </button>
                </div>
            ) : null}
            <div className="pipeline">
                {(row.stages || []).map((stage, index) => {
                    const sorted = Boolean(stage.sorted?.checked);
                    const implemented = Boolean(stage.implemented?.checked);
                    const removed = Boolean(stage.removed);
                    const stateClass =
                        sorted && implemented ? "done" : sorted || implemented ? "partial" : "";
                    return (
                        <div
                            className={`pipeline-stage-wrap ${removed ? "is-removed" : ""}`}
                            key={`${row.machine_id}-${stage.key || stage.stageName}`}
                        >
                            <div className={`pipeline-stage ${stage.shape} ${stateClass}`}>
                                <span>{stage.stageName}</span>
                                {removed ? <em className="pipeline-removed-tag">Removed</em> : null}
                            </div>
                            <div className="stage-checks">
                                <button
                                    type="button"
                                    title="Sorted means the requirement, design or dependency is resolved."
                                    className={sorted ? "checked" : ""}
                                    disabled={!canEdit}
                                    onClick={() =>
                                        onPatch(row.machine_id, {
                                            action: "toggle",
                                            key: "sorted",
                                            stage_index: index,
                                        })
                                    }
                                >
                                    Sorted
                                </button>
                                <button
                                    type="button"
                                    title="Implemented means the stage has been physically or digitally completed."
                                    className={implemented ? "checked" : ""}
                                    disabled={!canEdit}
                                    onClick={() =>
                                        onPatch(row.machine_id, {
                                            action: "toggle",
                                            key: "implemented",
                                            stage_index: index,
                                        })
                                    }
                                >
                                    Implemented
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </article>
    );
};

export default MachinePipelineCard;
